import script from "./PortfoliosPageWithFilters.vue?vue&type=script&lang=ts&setup=true"
export * from "./PortfoliosPageWithFilters.vue?vue&type=script&lang=ts&setup=true"

import "./PortfoliosPageWithFilters.vue?vue&type=style&index=0&id=4c2babc2&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/curl-fe-build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4c2babc2"]])

export default __exports__